<div class="photoeditor-modal" [ngClass]="{ 'show-modal': showModal }">
  <div class="photoeditor-modal__content">
    <div class="photoeditor-modal__header">
      <h3><span>Your comment</span></h3>
      <div class="close-button"  (click)="save()">
        <span class="material-icons-outlined">close</span>
      </div>
    </div>
    <div class="photoeditor-modal__body">
      <textarea [(ngModel)]="description" rows="10" cols="50"></textarea>
    </div>
    <div>
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6 close-modal-button" (click)="cancel()">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left"><span>Cancel</span></div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6 save-modal-button" (click)="save()">
          <button type="submit" class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right">
            <span>Save</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
